"use client";

import { cn } from "@/lib";
import { useEffect, useState } from "react";
import { BdMapArrowUp } from "solar-icon-react/bd";

const ScrollUp = ({ className }: { className?: string }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const thresholdPx = window.innerHeight * 0.4;
      setIsVisible(window.scrollY > thresholdPx);
    };

    // Initialize on mount in case user loads mid-page
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <section
      className={cn(
        "fixed bottom-[90px] left-[10px] z-[40] md:bottom-[80px] md:left-[30px]",
        className,
      )}
    >
      <button
        id="scroll-up-button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`bg-primary-main hover:bg-hero-section-main cursor-pointer rounded-md border border-white p-3 text-white shadow-xl transition-all duration-300 ease-out hover:border-transparent ${
          isVisible
            ? "pointer-events-auto translate-y-0 opacity-100"
            : "pointer-events-none translate-y-2 opacity-0"
        }`}
        aria-label="Scroll to top"
      >
        <BdMapArrowUp size={18} />
      </button>
    </section>
  );
};

export default ScrollUp;
